import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

import GuestsCount from './GuestsCount';
import PrivateTitle from "./PrivateTitle";
import BePrivateButton from "./BePrivateButton";
import DownBar from "./DownBar";
import backgroundVideo from "../assets/background_video.mp4";
import TicketsButton from './TicketsButton';
import "../styles/global.css";


function OrderPage() {

  const navigate = useNavigate();
  const [ShowContinuteButton, setShowContinuteButton] = useState(false);
  const [guestsNumber, setguestsNumber] = useState(0);
  const [ticketPrice, setticketPrice] = useState(100);

  const navigateToOrder = () => {
    navigate("/order");
  };

  return (
    <div className="main-container">
        <video
            className="background-video"
            src={backgroundVideo}
            autoPlay
            loop
            muted
            playsInline
        />
        <div className="content">
            <PrivateTitle />
            <GuestsCount ChangeGuests={setguestsNumber} GuestsCountNumber={guestsNumber}/>
            {/* <div className='continue-button-container-placement'> */}
              {
                guestsNumber >= 1 && (
                <TicketsButton tickets={guestsNumber} price={ticketPrice}/>
              )}       
            {/* </div>
             */}
        </div>
        <div className="buttom-page">
            <DownBar />
       </div>
    </div>
);
}
export default OrderPage;
